/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompactFlightOffer } from './CompactFlightOffer';
import {
    CompactFlightOfferFromJSON,
    CompactFlightOfferFromJSONTyped,
    CompactFlightOfferToJSON,
    CompactFlightOfferToJSONTyped,
} from './CompactFlightOffer';
import type { PriceModelOffer } from './PriceModelOffer';
import {
    PriceModelOfferFromJSON,
    PriceModelOfferFromJSONTyped,
    PriceModelOfferToJSON,
    PriceModelOfferToJSONTyped,
} from './PriceModelOffer';
import type { CompactCabinCategoryOffer } from './CompactCabinCategoryOffer';
import {
    CompactCabinCategoryOfferFromJSON,
    CompactCabinCategoryOfferFromJSONTyped,
    CompactCabinCategoryOfferToJSON,
    CompactCabinCategoryOfferToJSONTyped,
} from './CompactCabinCategoryOffer';

/**
 * A container for a list of offers
 * @export
 * @interface CompactOffers
 */
export interface CompactOffers {
    /**
     * A list of available price price models
     * @type {Array<PriceModelOffer>}
     * @memberof CompactOffers
     */
    priceModelOffers: Array<PriceModelOffer>;
    /**
     * A list of available cabin category offers
     * @type {Array<CompactCabinCategoryOffer>}
     * @memberof CompactOffers
     */
    cabinCategoryOffers: Array<CompactCabinCategoryOffer>;
    /**
     * 
     * @type {CompactFlightOffer}
     * @memberof CompactOffers
     */
    bestPriceflightOffer?: CompactFlightOffer;
    /**
     * Flag to indicate that flex flight is bookable
     * @type {boolean}
     * @memberof CompactOffers
     */
    flexFlight: boolean;
}

/**
 * Check if a given object implements the CompactOffers interface.
 */
export function instanceOfCompactOffers(value: object): value is CompactOffers {
    if (!('priceModelOffers' in value) || value['priceModelOffers'] === undefined) return false;
    if (!('cabinCategoryOffers' in value) || value['cabinCategoryOffers'] === undefined) return false;
    if (!('flexFlight' in value) || value['flexFlight'] === undefined) return false;
    return true;
}

export function CompactOffersFromJSON(json: any): CompactOffers {
    return CompactOffersFromJSONTyped(json, false);
}

export function CompactOffersFromJSONTyped(json: any, ignoreDiscriminator: boolean): CompactOffers {
    if (json == null) {
        return json;
    }
    return {
        
        'priceModelOffers': ((json['priceModelOffers'] as Array<any>).map(PriceModelOfferFromJSON)),
        'cabinCategoryOffers': ((json['cabinCategoryOffers'] as Array<any>).map(CompactCabinCategoryOfferFromJSON)),
        'bestPriceflightOffer': json['bestPriceflightOffer'] == null ? undefined : CompactFlightOfferFromJSON(json['bestPriceflightOffer']),
        'flexFlight': json['flexFlight'],
    };
}

export function CompactOffersToJSON(json: any): CompactOffers {
    return CompactOffersToJSONTyped(json, false);
}

export function CompactOffersToJSONTyped(value?: CompactOffers | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'priceModelOffers': ((value['priceModelOffers'] as Array<any>).map(PriceModelOfferToJSON)),
        'cabinCategoryOffers': ((value['cabinCategoryOffers'] as Array<any>).map(CompactCabinCategoryOfferToJSON)),
        'bestPriceflightOffer': CompactFlightOfferToJSON(value['bestPriceflightOffer']),
        'flexFlight': value['flexFlight'],
    };
}

